import { PRODUCTS_URLS } from '../constants';

const getCurrentProduct = () => {
  const path = window.location.pathname.toLowerCase();
  return PRODUCTS_URLS.find(({
    url
  }) => path.startsWith(url));
};

export default getCurrentProduct;
//# sourceMappingURL=getCurrentProduct.js.map